// extracted by mini-css-extract-plugin
module.exports = {"ibanuppercase":"aanvrager-burgelijke-status_ibanuppercase__2PJMO"};